import React, { useEffect, useState } from "react";

function Profile() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetch("http://localhost:5000/me", {
      credentials: "include",
    })
      .then(res => res.json())
      .then(data => setUser(data))
      .catch(() => setUser(null));
  }, []);

  if (!user) {
    return (
      <div className="card">
        <h2 className="title">❌ Not Logged In</h2>
        <p>Please login again</p>
      </div>
    );
  }

  return (
    <div className="card">
      <img src={user.avatar} className="avatar" alt="" />
      <h2>{user.name}</h2>
      <p className="email">{user.email}</p>

      <button
        className="btn"
        onClick={() => {
          fetch("http://localhost:5000/logout", {
            method: "POST",
            credentials: "include",
          }).then(() => (window.location.href = "/"));
        }}
      >
        Logout
      </button>
    </div>
  );
}

export default Profile;
